import { useGetCnpj } from 'hooks/useGetCnpj';
import { useTabs } from 'hooks/useTabs';
import React, { createContext, FC } from 'react';

interface ITabsContext {
    stepSelected: number;
    currentItem: any;
    width: string | number;
    component: React.ReactElement;
    keys: string[];
    tabName: string;
    steps: Record<string, { nome: string; formularioSucesso: boolean }>;
    selectTab: (args: { proximo: string; data?: any }) => void;
    getInitialDataByName: (key: string) => any;
    updateInitialData: (key: string, data: any) => void;
}

interface ICnpjContext {
    loading: boolean;
    loadBusiness: (formRef: any) => Promise<void>;
    data?: any;
}

interface INavigateContextValue {
    cnpj: ICnpjContext;
    tabs: ITabsContext;
}

export const NavigateContext = createContext<INavigateContextValue | undefined>(undefined);

export const NavigateProvider: FC<any> = ({ dataTabs, children }) => {
    // Controlando as janelas e validando os erros
    const tabs = useTabs({ abas: dataTabs });

    // Validando e buscando CNPJ
    const cnpj = useGetCnpj();

    // Render
    return (
        <NavigateContext.Provider
            value={{
                cnpj,
                tabs,
            }}
        >
            {children}
        </NavigateContext.Provider>
    );
};
